import * as React from 'react';
import { createPortal } from 'react-dom';
import cn from 'classnames';

import * as styles from './styles.css';

import { InlineText1 } from '@cian/ui-kit/typography';

export interface IErrorTooltipProps {
  text: string;
}

export function ErrorTooltip({ text }: IErrorTooltipProps) {
  const [mount, setMount] = React.useState(false);

  React.useEffect(() => {
    setMount(true);
  }, []);

  return createPortal(
    <div className={cn(styles['container'], mount && styles['active'])}>
      <InlineText1 color="white_100">{text}</InlineText1>
    </div>,
    document.body,
  );
}
